import {useTranslation} from "react-i18next";
import {TxtTitles} from "../../../../../../../../helpers/breadCrumbs";
import {ListInformationElement} from "./ListInformationElement";
import React from "react";

const AddMusCostsMainTitles = () => {
    const { t } = useTranslation();

    const fields = [
        {
            title: '',
            widthLimit: '3%'
        },
        {
            title: <TxtTitles>{t('events.summary.musicians')}</TxtTitles>,
            widthLimit: '23%'
        },
        {
            title: <TxtTitles>{t('events.summary.instrument')}</TxtTitles>,
            widthLimit: '17%'
        },
        {
            title: <TxtTitles>{t('events.summary.client_costs')}</TxtTitles>,
            widthLimit: '27%',
            style: { margin: '0 auto', textAlign: 'center' }
        },
        {
            title: <TxtTitles>{t('events.summary.estro_costs')}</TxtTitles>,
            widthLimit: '27%',
            style: { margin: '0 auto', textAlign: 'center' }
        },
        {
            title: '',
            widthLimit: '3%'
        },
    ];
    return <ListInformationElement fields={fields} />;
}

export default AddMusCostsMainTitles

